import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import { saveAs } from "file-saver";

function DocumentosTab({ docs, id }) {
    const navigate = useNavigate();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedDocs, setSelectedDocs] = useState([]); // Armazena os documentos em um estado para facilitar a atualização da UI
    const [documents, setDocuments] = useState(docs);
    const fileInputRef = useRef(null);
    // Estado para controlar quantos arquivos foram selecionados para upload
    const [selectedFilesCount, setSelectedFilesCount] = useState(0);

    const handleChooseFiles = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const dataFormato = (date) => {
        const dataAtual = new Date(date);
        const dia = String(dataAtual.getDate()).padStart(2, "0");
        const mes = String(dataAtual.getMonth() + 1).padStart(2, "0");
        const ano = dataAtual.getFullYear();
        return `${dia}/${mes}/${ano}`;
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        let file = event.target.files;
        // Atualiza o estado com a quantidade de arquivos selecionados
        setSelectedFilesCount(file.length);
        setSelectedFiles(files);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        setSelectedFiles(files);
        setSelectedFilesCount(files.length);
        if (fileInputRef.current) {
            const dataTransfer = new DataTransfer();
            files.forEach((file) => dataTransfer.items.add(file));
            fileInputRef.current.files = dataTransfer.files;
        }
    };

    const handleRemoveSelectedFile = (idx) => {
        const newFiles = selectedFiles.filter((_, i) => i !== idx);
        setSelectedFiles(newFiles);
        setSelectedFilesCount(newFiles.length);
        if (fileInputRef.current) {
            const dt = new DataTransfer();
            newFiles.forEach((file) => dt.items.add(file));
            fileInputRef.current.files = dt.files;
        }
    };

    // Função para lidar com a seleção de um único documento
    const handleSelectDoc = (id) => {
        setSelectedDocs((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((docId) => docId !== id)
                : [...prevSelected, id]
        );
    };
    // Função para selecionar ou desmarcar todos os documentos
    const handleSelectAll = () => {
        if (selectedDocs.length === documents.length) {
            setSelectedDocs([]);
        } else {
            setSelectedDocs(documents.map((doc) => doc.id));
        }
    };

    // download em lote usando JSZip com tratamento de erros
    const downloadDocs = async (ids, zipName) => {
        if (!ids.length) return;
        const zip = new JSZip();
        for (const docId of ids) {
            const doc = documents.find((d) => d.id === docId);
            const filename = doc?.nome || `documento-${docId}`;
            try {
                const res = await fetch(`/api/download/documento/${docId}`, {
                    credentials: "include",
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const blob = await res.blob();
                zip.file(filename, blob);
            } catch (err) {
                console.error(`Erro ao baixar documento ${docId}:`, err);
            }
        }
        zip.generateAsync({ type: "blob" })
            .then((content) => saveAs(content, zipName))
            .catch((err) => {
                console.error("Erro ao gerar ZIP:", err);
                alert("Falha ao gerar ZIP.");
            });
    };

    const downloadSelected = () =>
        downloadDocs(selectedDocs, "selecionados.zip");
    const downloadAll = () =>
        downloadDocs(
            documents.map((d) => d.id),
            "todos-documentos.zip"
        );

    // Função para excluir os documentos selecionados
    // const deleteSelected = async () => {
    //     if (selectedDocs.length === 0) {
    //         alert("Selecione ao menos um documento para excluir.");
    //         return;
    //     }
    //     if (
    //         !window.confirm(
    //             "Tem certeza de que deseja excluir os documentos selecionados?"
    //         )
    //     ) {
    //         return;
    //     }
    //     try {
    //         // Exclui cada documento selecionado
    //         await Promise.all(
    //             selectedDocs.map(async (docId) => {
    //                 // Use axios.post ou axios.delete conforme sua API (aqui usamos axios.post como exemplo)
    //                 const response = await axios.post(
    //                     `/api/remove/document/${docId}`,
    //                     null,
    //                     { withCredentials: true }
    //                 );
    //                 if (response.data.status !== 200) {
    //                     throw new Error(`Erro ao excluir documento ${docId}`);
    //                 }
    //             })
    //         );
    //         // Atualiza a lista removendo os documentos excluídos
    //         setDocuments((prevDocs) =>
    //             prevDocs.filter((doc) => !selectedDocs.includes(doc.id))
    //         );
    //         setSelectedDocs([]);
    //     } catch (error) {
    //         console.error("Erro ao excluir os documentos selecionados:", error);
    //         alert("Erro ao excluir os documentos selecionados.");
    //     }
    // };

    // // Função para excluir TODOS os documentos
    // const deleteAll = async () => {
    //     if (documents.length === 0) {
    //         alert("Não há documentos para excluir.");
    //         return;
    //     }
    //     if (
    //         !window.confirm(
    //             "Tem certeza de que deseja excluir todos os documentos?"
    //         )
    //     ) {
    //         return;
    //     }
    //     try {
    //         await Promise.all(
    //             documents.map(async (doc) => {
    //                 const response = await axios.post(
    //                     `/api/remove/document/${doc.id}`,
    //                     null,
    //                     { withCredentials: true }
    //                 );
    //                 if (response.data.status !== 200) {
    //                     throw new Error(`Erro ao excluir documento ${doc.id}`);
    //                 }
    //             })
    //         );
    //         // Limpa a lista de documentos e os selecionados
    //         setDocuments([]);
    //         setSelectedDocs([]);
    //     } catch (error) {
    //         console.error("Erro ao excluir todos os documentos:", error);
    //         alert("Erro ao excluir todos os documentos.");
    //     }
    // };

    return (
        <div className="tab-pane fade" id="sexta-aba" role="tabpanel">
            <div className="card-body table-responsive p-0">
                <table className="table table-striped table-bordered mt-10">
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={
                                        selectedDocs.length === documents.length
                                    }
                                />
                            </th>
                            <th>Nome do Arquivo</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        {documents.map((dados) => (
                            <tr key={dados.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedDocs.includes(
                                            dados.id
                                        )}
                                        onChange={() =>
                                            handleSelectDoc(dados.id)
                                        }
                                    />
                                </td>
                                <td>
                                    <label title="Clique para baixar o arquivo">
                                        <a
                                            style={{
                                                color: "green",
                                            }}
                                            href={`https://guias.almeidaenogueira.com.br/api/download/documento/${dados.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <i className="fa fa-cloud-download mr-3" />
                                            {dados.nome}
                                        </a>
                                    </label>
                                </td>
                                <td>{dataFormato(dados.data)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="mt-3">
                    <button
                        className="btn btn-primary mr-2"
                        onClick={downloadSelected}
                        disabled={selectedDocs.length === 0}>
                        Baixar Selecionados
                    </button>
                    <button className="btn btn-secondary" onClick={downloadAll}>
                        Baixar Todos
                    </button>
                    {/* <button
                        className="btn btn-danger"
                        onClick={deleteSelected}
                        disabled={selectedDocs.length === 0}>
                        Excluir Selecionados
                    </button>
                    <button
                        className="btn btn-warning"
                        onClick={deleteAll}
                        disabled={documents.length === 0}>
                        Excluir Todos
                    </button> */}
                </div>
            </div>
            <form
                action={`/api/novo/documento/${id}`}
                method="post"
                encType="multipart/form-data"
                className="p-4 border rounded shadow-sm bg-white"
                style={{ maxWidth: "600px", margin: "40px auto" }}>
                <h4 className="mb-4 text-center">Envie seu Documento</h4>

                <div className="mb-3">
                    <label className="form-label">Selecione os Arquivos:</label>
                    <div
                        className="file-drop-area border rounded p-4 d-flex flex-column align-items-center"
                        style={{
                            cursor: "pointer",
                            minHeight: "150px",
                            justifyContent: "center",
                        }}
                        onClick={handleChooseFiles}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}>
                        {/* Input file oculto */}
                        <input
                            ref={fileInputRef}
                            name="upload"
                            id="inputDocs"
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />
                        <div className="text-center">
                            <button
                                type="button"
                                className="btn btn-outline-primary mb-2">
                                Escolha o(s) Arquivo(s)
                            </button>
                            <p className="mb-0 text-muted">
                                ou arraste e solte os arquivos aqui
                            </p>
                        </div>
                    </div>
                </div>

                {selectedFiles.length > 0 && (
                    <div className="mb-3">
                        <h6 className="mb-2">Arquivos Selecionados:</h6>
                        <ul className="list-group">
                            {selectedFiles.map((file, index) => (
                                <li
                                    key={index}
                                    className="list-group-item d-flex align-items-center">
                                    <span className="flex-grow-1 text-truncate">
                                        {file.name}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger ml-2"
                                        onClick={() =>
                                            handleRemoveSelectedFile(index)
                                        }>
                                        Excluir
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="text-center">
                    <button
                        type="submit"
                        className="btn btn-success"
                        disabled={selectedFilesCount === 0}>
                        Salvar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default DocumentosTab;
